import { css, unsafeCSS } from 'lit-element';
import { litStyle } from 'lit-element-style';
import { cssVars } from 'styles/vars.js';

export const formStyles = litStyle(css`

  .field {
    display: block;
    margin-bottom: 15px;
  }

  .field .label {
    margin-bottom: 10px;
    font-weight: 600;
  }

  textarea,
  input[type=text],
  input[type=email] {
    background-color: ${unsafeCSS(cssVars.white)};
    border-radius: 5px;
    width: 100%;
    width: -moz-available;
    width: -webkit-fill-available;
    font-size: 1em;
    padding: .75em;
    box-shadow: none;
    border: 0;
    color: ${unsafeCSS(cssVars.input_color)};
  }

  textarea {
    resize: vertical;
  }

`);
